var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pointMapwrap"}},[_c('div',{attrs:{"id":"searchAdd"}},[_c('search-add',{on:{"adds":_vm.reAdds}})],1),_vm._v(" "),_c('div',{attrs:{"id":"pointMap"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1157df72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map20/point.vue
// module id = null
// module chunks = 